type FrameRenderCompleteSource = {
    onRenderComplete: (callback: (args: { frameId: number; canvas: HTMLCanvasElement }) => void) => number;
};

type EventListenerDisposer = {
    off: (listenerId: number) => void;
};

type SubscribeHierarchyIconRefreshOptions = {
    frame: FrameRenderCompleteSource;
    events: EventListenerDisposer;
    getCurrentFrameId: () => number;
    onRefresh: () => void;
};

/**
 * 图层管理器只在当前 Frame 完成绘制后刷新缩略图，不重新拉取图层树。
 */
export const subscribeHierarchyIconRefresh = ({
    frame,
    events,
    getCurrentFrameId,
    onRefresh,
}: SubscribeHierarchyIconRefreshOptions) => {
    const listener = frame.onRenderComplete(({ frameId }) => {
        if (frameId !== getCurrentFrameId()) return;
        onRefresh();
    });

    return () => events.off(listener);
};
